module.exports = __webpack_public_path__ + "img/logo.957ef3b7.png";